import { getAutocompleteEquality } from '@Utils/helpers/muiHelpers';
import {
    Autocomplete,
    AutocompleteChangeReason,
    TextField,
} from '@mui/material';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React from 'react';

const FolderFieldsSelector = (props) => {
    const {
        folderFields,
        selectedFolderField,
        onSelectFolderField,
        isLoading,
        id,
    } = props;

    const handleOnChange = (value: any, reason: AutocompleteChangeReason) => {
        const field = folderFields[value.id];
        switch (reason) {
            case 'clear':
                onSelectFolderField(null);
                break;
            case 'selectOption':
                onSelectFolderField(field);
                break;
            default:
                break;
        }
    };

    const fieldOptions = folderFields.map((f, i) => {
        return { label: f, id: i };
    });

    const value = !_isNil(selectedFolderField) ? selectedFolderField : '';

    return (
        <Autocomplete
            id={id}
            options={fieldOptions}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={'Attribute'}
                    value={selectedFolderField}
                />
            )}
            onChange={(e, value, reason) => handleOnChange(value, reason)}
            value={value}
            size="small"
            style={{ width: 300 }}
            loading={isLoading}
            isOptionEqualToValue={(option, value) =>
                getAutocompleteEquality(option, value.label)
            }
        />
    );
};

FolderFieldsSelector.propTypes = {
    folderFields: PropTypes.array,
    selectedFolderField: PropTypes.string,
    onSelectFolderField: PropTypes.func,
    isLoading: PropTypes.bool,
    id: PropTypes.string,
};

export default FolderFieldsSelector;
